import { Brand } from './brand';
import { ComplementType } from './complement-type';

export class Complement {
  constructor(
    public hash?: string,
    public name?: string,
    public code?: string,
    public price?: number,
    public weight?: number,
    public needSerialNumber?: boolean,
    public description?: string,
    public complementType?: ComplementType,
    public brand?: Brand
  ) { }

  get fullName() {
    return `${ this.name } (${ this.code })`;
  }

  clone() {
    return new Complement(
      this.hash,
      this.name,
      this.code,
      this.price,
      this.weight,
      this.needSerialNumber,
      this.description,
      this.complementType,
      this.brand
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/complement.ts